import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  TextField,
} from "@mui/material";
import { CARD_TYPES } from "../../helper/cardTypes";
import { useLanguage } from "../../i18n/LanguageContext";

// Edits a card's optional details: its type, who runs it and a note. The
// fields are local until "Save", so typing doesn't push a new URL (and a
// new history entry) on every keystroke.
export default function CardDetailsDialog({ task, open, onClose, onSave }) {
  const [type, setType] = useState(task.type || "");
  const [owner, setOwner] = useState(task.owner || "");
  const [note, setNote] = useState(task.note || "");
  const { t } = useLanguage();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      slotProps={{ paper: { className: "card-details-dialog" } }}
    >
      <form
        onSubmit={(event) => {
          event.preventDefault();
          // undefined drops the key from the stored JSON entirely.
          onSave({
            type: type || undefined,
            owner: owner.trim() || undefined,
            note: note.trim() || undefined,
          });
        }}
      >
        <DialogTitle>{task.topic || t("common.untitled")}</DialogTitle>
        <DialogContent className="card-details-fields">
          <TextField
            select
            variant="standard"
            label={t("cardDetails.type")}
            value={type}
            onChange={(event) => setType(event.target.value)}
            slotProps={{
              inputLabel: { shrink: true },
              select: { displayEmpty: true },
            }}
          >
            <MenuItem value="">
              <em>{t("cardDetails.none")}</em>
            </MenuItem>
            {Object.entries(CARD_TYPES).map(([key, { color }]) => (
              <MenuItem key={key} value={key}>
                <span
                  className="card-type-swatch"
                  style={{ background: color }}
                />
                {t(`cardTypes.${key}`)}
              </MenuItem>
            ))}
          </TextField>
          <TextField
            variant="standard"
            label={t("cardDetails.owner")}
            placeholder={t("cardDetails.ownerPlaceholder")}
            value={owner}
            onChange={(event) => setOwner(event.target.value)}
            slotProps={{
              htmlInput: { maxLength: 40 },
              inputLabel: { shrink: true },
            }}
          />
          <TextField
            variant="standard"
            label={t("cardDetails.note")}
            placeholder={t("cardDetails.notePlaceholder")}
            multiline
            minRows={3}
            value={note}
            onChange={(event) => setNote(event.target.value)}
            slotProps={{
              htmlInput: { maxLength: 500 },
              inputLabel: { shrink: true },
            }}
          />
        </DialogContent>
        <DialogActions>
          <Button color="inherit" onClick={onClose}>
            {t("common.cancel")}
          </Button>
          <Button type="submit" variant="outlined">
            {t("common.save")}
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
}
